export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_23.32d5d38e.jpg";